import { initializeClientSubApplication } from "./load-application";
import InfoBaseList from "../components/InfoBaseList";

initializeClientSubApplication("infobase-list-react-", InfoBaseList);
